import React, { useLayoutEffect, useRef } from 'react'
import classNames from 'classnames'

import { FullScreenLoader } from '../Loading'

interface Props {
  loading: boolean
  disableScroll?: boolean
  onIntersect: () => void
}

export const Observer: React.FC<Props> = ({
  loading,
  disableScroll,
  onIntersect,
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const callback = useRef(onIntersect)

  useLayoutEffect(() => {
    callback.current = onIntersect
  }, [onIntersect])

  useLayoutEffect(() => {
    if (!ref.current) return undefined

    const observer = new IntersectionObserver(
      entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          callback.current()
        }
      },
      {
        threshold: 0.2,
      },
    )

    observer.observe(ref.current)

    return () => observer.disconnect()
  }, [])

  return (
    <div ref={ref} className={classNames('observer', { loading })}>
      {loading && <FullScreenLoader disableScroll={disableScroll} />}
    </div>
  )
}
